import React, { Component } from "react";
import { Redirect, Route, Switch } from "react-router-dom";

import { setLogoutFunction } from "api/api";

import { getGroup } from "utils/auth";
import { connect } from "react-redux";

import { Creators as ActionsAuth } from "ducks/Auth";
import { Creators as ActionsGeral } from "ducks/Geral";

import MomentUtils from "@date-io/moment";

import { MuiPickersUtilsProvider } from "material-ui-pickers";

import { IntlProvider } from "react-intl";

import Loadable from "react-loadable";

import { createMuiTheme, MuiThemeProvider } from "@material-ui/core/styles";

import LoadingComponent from "util/LoadingComponent";
import { hotjar } from 'react-hotjar';

import {
    setNotificationFunction,
    setDefaultFunction,
} from "utils/notification";

import Notificacao from "components/Notificacao";
import Alerta from "components/Alerta";
import { gaPageView, gaSetUser } from "components/GoogleTracking";

import defaultTheme from "./themes/defaultTheme";
import AppLocale from "../lngProvider";

import { DEFAULT_MODULE, DEFAULT_ROUTE, IF_NEW_USER, USER_DISABLED } from "./modules";

import "react-big-calendar/lib/less/styles.less";
import "styles/bootstrap.scss";
import "styles/app.scss";
import '../tutorialGuiado/style.css'

import { dateInTimezone } from 'utils/date'

import SideMenu from './SideMenu/index'
import FrontV4 from "./FrontV4";
import MixPanelTrack from "./Tracking";

import Modal from '@material-ui/core/Modal'
// import { checkSession } from "../utils/session";

const RestrictedRoute = ({ component: Component, authUser, ...rest }) => {
    return (
        <Route
            {...rest}
            render={(props) =>
                authUser ? (
                    <Component {...props} />
                ) : (
                    <Redirect
                        to={{
                            pathname: "/login",
                            state: { from: props.location },
                        }}
                    />
                )
            }
        />
    );
};

class App extends Component {
    constructor(props) {
        super(props);
        this.state = {
            // modalOpen: true
        };
    }

    componentDidMount() {
        const { auth, history } = this.props;

        if (auth.login) {
            gaSetUser(auth.email);
            gaPageView(history.location)
            history.listen(gaPageView);

            this.changeSidebar({
                dark: !!auth.super_user,
            });
        }

        // checkSession()

        this.setup();
        // hotjar.initialize(3411268,1)
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        const { auth } = nextProps;

        if (!auth.login) return;

        this.changeSidebar({
            dark: !!auth.super_user,
        });
    }

    setup = () => {
        const { setData, setMensagem, setErro } = this.props;

        setLogoutFunction(() => setData({}));

        setNotificationFunction({ bar: setMensagem, error: setErro });
        setDefaultFunction("bar");

        // eslint-disable-next-line no-extend-native
        String.prototype.capitalize = function () {
            return this.charAt(0).toUpperCase() + this.slice(1);
        };
        // eslint-disable-next-line no-extend-native
        String.prototype.replaceAll = function (search, replacement) {
            return this.split(search).join(replacement);
        };
    };

    changeSidebar = ({ dark }) => {
        const body = document.querySelector("body");

        if (dark) {
            body.classList.remove("dark-deep-orange");
            body.classList.add("dark-theme");
        } else {
            body.classList.remove("dark-theme");
            body.classList.add("dark-deep-orange");
        }
    };

    // handleCloseModal = () => {
    //     this.setState({ modalOpen: false });
    // };

    checkLocatinPathname = (location) => {
        let aux = USER_DISABLED.map((user) => user.route);
        return aux.find((route) =>
            location.pathname.startsWith("/app" + route)
        );
    };

    render() {
        const { match, location, locale, auth, isDirectionRTL, history } = this.props;
        dateInTimezone()
        if (
            !auth.login &&
            !location.pathname.startsWith("/login") &&
            !location.pathname.startsWith("/redefinir") &&
            !location.pathname.startsWith("/cadastrar")
        ) {
            return <Redirect to="/login" />;
        } else {
            if (
                auth.novo_user &&
                !location.pathname.startsWith("/app" + IF_NEW_USER.route)
            ) {
                return <Redirect to={"/app" + IF_NEW_USER.route} />;
            } else if (
                !auth.novo_user &&
                auth.login &&
                getGroup(auth).getUser().isGroupAtivos() &&
                !this.checkLocatinPathname(location)
            ) {
                if (!(auth.grupo_ativo == "BOXX" && auth.login == "12237548000139" && (
                    location.pathname.startsWith("/app/romaneios")))) {

                    return <Redirect to={"/app" + USER_DISABLED[0].route} />;
                }
            } else if (
                location.pathname === "/" ||
                location.pathname === "/app" ||
                location.pathname === "/app/"
            ) {
                if (!auth.login) {
                    return <Redirect to="/login" />;
                } else {
                    return <Redirect to={"/app" + DEFAULT_ROUTE.route} />;
                }
            }
            else if (auth.login && getGroup(auth)?.user?.grupo == "ENTREGADOR" && (
                location.pathname.includes("/documentos/devolucoes/criar") || location.pathname.includes("/documentos/devolucoes/editar")
            )) {
                return <Redirect to={"/app/documentos/devolucoes"} />
            }
        }

        const applyTheme = createMuiTheme(defaultTheme);

        if (isDirectionRTL) {
            applyTheme.direction = "rtl";
            document.body.classList.add("rtl");
        } else {
            document.body.classList.remove("rtl");
            applyTheme.direction = "ltr";
        }

        const currentAppLocale = AppLocale[locale.locale];

        return (
            <MuiThemeProvider theme={applyTheme}>
                <MuiPickersUtilsProvider utils={MomentUtils}>
                    <IntlProvider
                        locale={currentAppLocale.locale}
                        messages={currentAppLocale.messages}
                    >

                        <div className="app-main">
                            {/* Remover este modal assim que sistema voltar ao normal */}
                            {/* <Modal
                                open={this.state.modalOpen}
                            >
                                <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'flex-start', alignItems: 'center', position: 'absolute', background: 'white', top: 'calc(50% - 170px)', left: 'calc(50% - 300px)', width: '600px', minHeight: '340px', borderRadius: '20px', padding: '40px 30px', boxShadow: '0 4px 20px rgba(0,0,0,0.15)', boxSizing: 'border-box' }}>
                                    
                                    <button 
                                        onClick={this.handleCloseModal}
                                        style={{ position: 'absolute', top: '15px', right: '15px', background: 'transparent', border: 'none', fontSize: '24px', color: '#999', cursor: 'pointer', padding: '5px 10px', lineHeight: '1' }}
                                        onMouseEnter={(e) => e.target.style.color = '#333'}
                                        onMouseLeave={(e) => e.target.style.color = '#999'}
                                    >
                                        ✕
                                    </button>

                                    <div style={{ fontSize: '48px', color: '#ff9800', marginBottom: '20px' }}>⚠️</div>
                                    
                                    <h2 style={{ margin: '0 0 20px 0', color: '#333', fontSize: '24px', fontWeight: '600', textAlign: 'center' }}>
                                        Sistema em Manutenção
                                    </h2>
                                    
                                    <p style={{ margin: '0 0 20px 0', color: '#666', fontSize: '16px', textAlign: 'center', lineHeight: '1.5' }}>
                                        Lamentamos o ocorrido. Estamos realizando uma manutenção emergencial no sistema, algumas informações podem estar indisponíveis. Nossa equipe está trabalhando para restabelecer o sistema o mais rápido possível.
                                    </p>
                                    
                                    <p style={{ margin: '0', color: '#999', fontSize: '14px', textAlign: 'center' }}>
                                        Agradecemos sua compreensão.
                                    </p>
                        
                                </div>
                            </Modal> */}

                            <SideMenu />

                            <MixPanelTrack />

                            <Switch>

                                <RestrictedRoute
                                    path={`${match.url}app`}
                                    authUser={auth}
                                    component={Loadable({
                                        loader: () => import("app/"),
                                        loading: () => <LoadingComponent />,
                                    })}
                                />

                                <Route
                                    path="/login"
                                    component={Loadable({
                                        loader: () => import("./Auth/Login"),
                                        loading: () => <LoadingComponent />,
                                    })}
                                />

                                <Route
                                    path="/redefinir"
                                    component={Loadable({
                                        loader: () =>
                                            import("./Auth/Redefinir"),
                                        loading: () => <LoadingComponent />,
                                    })}
                                />

                                <Route
                                    path="/cadastrar"
                                    component={Loadable({
                                        loader: () => import("./Auth/Cadastro"),
                                        loading: () => <LoadingComponent />,
                                    })}
                                />

                                <Route
                                    component={Loadable({
                                        loader: () =>
                                            import("components/Error404"), // TODO: criar uma página de erro melhor, mais útil e mais bonita
                                        loading: () => <LoadingComponent />,
                                    })}
                                />
                            </Switch>

                            <Notificacao />
                            {localStorage.getItem("acordo") === "1" ||
                                sessionStorage.getItem("acordo") === "1" ||
                                !auth.login ? null : (
                                <Alerta history={this.props.history} />
                            )}

                            <FrontV4 auth={auth} location={location} history={history} />

                        </div>
                    </IntlProvider>
                </MuiPickersUtilsProvider>
            </MuiThemeProvider>
        );
    }
}

const mapStateToProps = ({ settings, auth }) => {
    const { sideNavColor, locale, isDirectionRTL } = settings;

    return { sideNavColor, locale, isDirectionRTL, auth };
};

const { setMensagem, setErro } = ActionsGeral;
const { setData, updateData } = ActionsAuth;

export default connect(mapStateToProps, {
    setMensagem,
    setErro,
    setData,
    updateData,
})(App);
